import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';

const BooleanField = props => {
  return (
    <FormGroup>
      <FormControlLabel
        required={props.required || false}
        label={props.label || null}
        control={
          <Checkbox
            defaultChecked={!!props?.defaultValue}
            onChange={e => props.onChange(e, !!e?.target?.checked)}
            sx={{
              color: 'text.gray',
            }}
          />
        }
      />
      {props.helperTest && <FormHelperText>
          <Typography
            variant='body1'
            color='text.primary'
          >
            {props.helperText}
          </Typography>
        </FormHelperText>
      }
    </FormGroup>
  );
};

export default BooleanField;